import {
    SiCplusplus,
    SiFramer,
    SiGithub, SiNeovim,
    SiNextdotjs,
    SiReact,
    SiRust,
    SiTailwindcss,
    SiTypescript,
    SiZig,
    SiLua,
    SiJavascript,
    SiNodedotjs,
} from "react-icons/si";
import {IconType} from "react-icons";

export type ProjectProps = {
  id: number;
  name: string;
  description: string;
  technologies: IconType[];
  techNames: string[];
  techLinks: string[];
  github: string;
  demo: string;
  image: string;
  available: boolean;
};

export const projects = [
    {
        id: 0,
        name: "Server Developer & Maintainer @ furyrp.ro",
        description: "",
        technologies: [SiLua, SiJavascript],
        techNames: ["Lua", "Javascript"],
        techLinks: ["https://lua.rocks/","https://www.javascript.com/"],
        github: "https://github.com/nuIIpointerexception/www.seekvisualartist.com",
        demo: "https://panel.furyrp.ro/",
        image: "/projects/portfolio.webp",
        available: true,
    },
    {
        id: 1,
        name: "Code Wars Solutions",
        description:
            "Just a couple of solutions for www.codewars.com problems. I'm currently ranked 6 kyu.",
        technologies: [SiCplusplus, SiRust, SiNodedotjs],
        techNames: ["C++", "Rust", "Node.JS"],
        techLinks: ["https://cplusplus.com/", "https://www.rust-lang.org/", "https://nodejs.org/"],
        github: "https://github.com/nuIIpointerexception/codewars",
        demo: "https://www.codewars.com/",
        image: "/projects/codewars.webp",
        available: true,
    },
    {
        id: 2,
        name: "Coming Soon",
        description:
            "Free Fire Tournaments - ONLINE w/ @nicustoicaaa.",
        technologies: [SiTypescript, SiRust, SiNextdotjs, SiTailwindcss, SiFramer],
        techNames: ["TypeScript", "Rust", "Next.js", "Tailwind CSS", "Framer"],
        techLinks: ["https://www.typescriptlang.org/", "https://www.rust-lang.org/", "https://nextjs.org/", "https://tailwindcss.com/", "https://www.framer.com/motion/"],
        github: "https://github.com/nuIIpointerexception/",
        demo: "https://github.com/nuIIpointerexception/",
        image: "/projects/construction.webp",
        available: false,
    },
];
